import { Link } from "react-router-dom";
import translate from "../locales";
import { THEMES } from "../themes";

export function NextTheme({ apiClient }) {
  const answeredThemes = apiClient.treesponses.map((t) => t.getAnswer("theme"));
  const availableThemes = Object.keys(THEMES).filter(
    (t) => !answeredThemes.includes(t),
  );

  if (availableThemes.length === 0) {
    return (
      <>
        <title>{translate("thanks.title")}</title>
        <main className="next">
          <div className="next__intro">
            <h1 className="next__title">{translate("thanks.title")}</h1>
            <p className="next__description">
              {translate("thanks.description")}
            </p>
          </div>
          <a
            href={translate(["general", "bpart_url"])}
            className="next__link next__link--button"
          >
            {translate("thanks.to_homepage")}
          </a>
        </main>
      </>
    );
  }

  return (
    <>
      <title>{translate("next_theme.title")}</title>
      <main className="next">
        <div className="next__intro">
          <h1 className="next__title">{translate("next_theme.title")}</h1>
          <p className="next__description">
            {translate("next_theme.description")}
          </p>
        </div>
        <div className="next__options">
          {availableThemes.map((theme) => (
            <Link
              to={`/${theme}`}
              key={theme}
              className="next__link next__link--button"
            >
              {translate([theme, "name"])}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="currentColor"
                className="next__link-icon"
              >
                <path d="M15.2188 11.25H0V8.75H15.2188L8.21875 1.75L10 0L20 10L10 20L8.21875 18.25L15.2188 11.25Z" />
              </svg>
            </Link>
          ))}
        </div>

        <div className="next__links">
          <a
            href={translate(["general", "bpart_url"])}
            className="next__link next__link--plain"
          >
            {translate("next_subtheme.to_homepage")}
          </a>
        </div>
      </main>
    </>
  );
}
